// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__jm9s7","table":"classes_table__2IXAP"};